/** API route map: URLS.Controller.Dashboard */
export const Dashboard = {
      Name: 'Dashboard/',
      UserSettings: 'user-settings',
      UserSettingsPatch: 'user-settings-patch',
      JobsOverviewWidget: 'jobs-overview-widget',
      ClientsOverviewWidget: 'clients-overview-widget',
      InvoiceAgingWidget: 'invoice-aging-widget',
      HiringPipelineWidget: 'hiring-pipeline-widget',
      EmployeeStatusWidget: 'employee-status-widget',
      EmployeeByClientWidget: 'employee-by-client-widget',
      CandidateStatusWidget: 'candidate-status-widget',
      CandidateStatusFunnelWidget: 'candidate-status-funnel-widget',
      JobTypeWidget: 'job-type-widget',
      CandidateTaskWidget: 'candidate-task-widget',
      CandidateSourceWidget: 'candidate-source-widget',
      JobRequisitionWidget: 'jobs-requisition-widget',
      JobsAssessmentWidget: 'job-assessment-widget',
      JobsHiringStatusWidget: 'job-hiring-status',
      GetAllPublishedJobs: 'published-jobs-list',
      EmployeeEarningWidge: 'employee-earn-widget',
      ReporSummaryWidget: 'reporter-summary-widget',
      PaycheckRegisterWidget: 'paycheck-register-widget',
      BillRateWidget: 'bill-rate-widget',
      HourlyRateWidget: 'hourly-rate-widget',
      DeductionWidget: 'deduction-widget',
};
